import type { H3Event } from 'h3'
import { isFetchingFromSubdomain } from '@composable-api-server/url'

export default function (event: H3Event) {
    // event is passed to overwrite the variables set during runtime
    // TODO: remove ts-ignore when the bug is fixed https://github.com/nuxt/nuxt/issues/24095
    // @ts-ignore
    return import.meta.dev ? isFetchingFromSubdomain(event) : true
}
